/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../common/token';
import '../../common/user_attributes';
import './status';
const $root = $protobuf.roots['square-experiments'] || ($protobuf.roots['square-experiments'] = new $protobuf.Root());
$root.addJSON({
  "squareup": {
    "nested": {
      "feature": {
        "nested": {
          "relay": {
            "nested": {
              "experiments": {
                "nested": {
                  "message": {
                    "nested": {
                      "RecordExclusionRequest": {
                        "fields": {
                          "experimentName": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "userToken": {
                            "type": "squareup.feature.relay.common.Token",
                            "id": 2,
                            "rule": "optional"
                          },
                          "exclusionReason": {
                            "type": "squareup.feature.relay.experiments.message.RecordExclusionRequest.ExclusionReason",
                            "id": 3,
                            "rule": "optional"
                          },
                          "userAttributes": {
                            "type": "squareup.feature.relay.common.UserAttributes",
                            "id": 4,
                            "rule": "optional"
                          },
                          "cdpKey": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "ExclusionReason": {
                            "values": {
                              "UNKNOWN": 0,
                              "EXCLUDED_FROM_EXPERIMENT": 1,
                              "MISSING_EXPERIMENT": 2,
                              "EXPERIMENT_MISCONFIGURED": 3
                            }
                          }
                        }
                      },
                      "RecordExclusionResponse": {
                        "fields": {
                          "status": {
                            "type": "squareup.feature.relay.experiments.message.Status",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
});

/**
 * SOURCE RecordExclusionRequest @ squareup/feature/relay/experiments/message/record_exclusion.proto at 13:1
 */
export const RecordExclusionRequest = $root.lookupType('squareup.feature.relay.experiments.message.RecordExclusionRequest');
fixType(RecordExclusionRequest, {
  experimentName: {
    required: true,
    notEmpty: true
  },
  userToken: {
    required: true
  },
  exclusionReason: {
    required: true
  }
});
Builder.createAndAttachToType(RecordExclusionRequest);
/**
 * SOURCE ExclusionReason @ squareup/feature/relay/experiments/message/record_exclusion.proto at 20:3
 */
RecordExclusionRequest.ExclusionReason = $root.lookupEnum('squareup.feature.relay.experiments.message.RecordExclusionRequest.ExclusionReason').values;
/**
 * SOURCE RecordExclusionResponse @ squareup/feature/relay/experiments/message/record_exclusion.proto at 36:1
 */
export const RecordExclusionResponse = $root.lookupType('squareup.feature.relay.experiments.message.RecordExclusionResponse');
fixType(RecordExclusionResponse);
Builder.createAndAttachToType(RecordExclusionResponse);